<template>
  <LoadingScreen id="loading-screen" />
  <Navbar />
  <div class="profile-section">
    <div class="profile-info">
      <div class="profile-image">
        <img
          :src="profileImage ? profileImage : '/paw.svg'"
          alt="Profile Image"
          style="width: 100%"
        />
        <div class="photo-uploader">
          <label for="profile-image-uploader">
            <fa id="upload-icon" icon="upload" />
          </label>
          <input
            type="file"
            id="profile-image-uploader"
            @change="handleFileUpload"
          />
        </div>
      </div>
      <div class="profile-text">
        <h1 id="name">{{ firstName }} {{ lastName }}</h1>
        <h4 id="email">{{ email }}</h4>
        <Button
          text="Account Settings"
          @click="this.$router.push('/account_settings')"
        />
      </div>
    </div>
    <Paw />
    <div class="user-assets">
      <div class="page-section">
        <h2 class="section-header">My Pets</h2>
        <div class="filter">
          <label for="filter">Show</label>
          <div class="select">
            <select
              name="filter"
              id="pet-filter-selector"
              v-model="petFilter"
              @change="updatePetFilterMethod"
            >
              <option selected="selected" value="all">All</option>
              <option value="Dog">Dog</option>
              <option value="Cat">Cat</option>
              <option value="Other">Other</option>
            </select>
          </div>
        </div>
        <div class="pets-container">
          <div class="pet" v-for="pet in filteredPets" :key="pet" :id="pet._id">
            <button :class="'edit-pet ' + device" @click="editPet(pet._id)">
              <fa icon="edit" />
            </button>
            <div class="pet-image">
              <img
                :src="backend + '/pets/images/' + pet._id"
                onerror="this.src='/paw.svg'"
                alt="Pet image"
              />
              <div class="photo-uploader">
                <label for="profile-image-uploader">
                  <fa id="upload-icon" icon="upload" />
                </label>
                <input
                  type="file"
                  id="profile-image-uploader"
                  @change="handleFileUpload($event, pet._id, 'pet')"
                />
              </div>
            </div>

            <div class="pet-info">
              <h3 class="pet-name">{{ pet.pet.name }}</h3>
              <p class="pet-race">
                {{ pet.pet.type }}<br />
                <span class="pet-breed">{{
                  pet.pet.breed.replaceAll("_", " ")
                }}</span>
              </p>
              <p class="pet-age">
                {{ pet.pet.age != 0 ? pet.pet.age + " y.o." : "-" }}
              </p>
              <p class="pet-behaviour">{{ pet.pet.behaviour }}</p>
              <p class="pet-size">{{ pet.pet.size }}</p>
            </div>
          </div>
        </div>
        <div class="add-pet">
          <CircularButton color="var(--dark-clr)" icon="plus" @click="addPet" />
        </div>
      </div>
      <VerticalBreak />
      <div class="page-section">
        <h2 class="section-header">My Businesses</h2>
        <div class="filter">
          <label for="filter">Show</label>
          <div class="select">
            <select
              name="filter"
              id="business-filter-selector"
              v-model="businessFilter"
              @change="updateBusinessFilterMethod"
            >
              <option selected="selected" value="all">All</option>
              <option value="Doctors">Doctors</option>
              <option value="Pet_supplies">Pet supplies</option>
              <option value="Groomers">Groomers</option>
              <option value="Trainers">Trainers</option>
              <option value="Nannies">Nannies</option>
              <option value="Hotels">Hotels</option>
              <option value="Walkers">Walkers</option>
              <option value="Shelters">Shelters</option>
              <option value="Other_Services">Other Services</option>
            </select>
          </div>
        </div>
        <div class="business-container">
          <div
            class="business"
            v-for="business in filteredBusiness"
            :key="business"
            :id="business._id"
          >
            <button
              :class="'edit-business ' + device"
              @click="editBusiness(business._id)"
            >
              <fa icon="edit" />
            </button>
            <div class="business-image">
              <img
                :src="backend + '/business/images/' + business.logo"
                onerror="this.src='/paw.svg'"
                alt="Business image"
              />
              <div class="photo-uploader">
                <label for="profile-image-uploader">
                  <fa id="upload-icon" icon="upload" />
                </label>
                <input
                  type="file"
                  id="profile-image-uploader"
                  @change="handleFileUpload($event, business._id, 'business')"
                />
              </div>
            </div>

            <div class="business-info">
              <h3 class="business-name">{{ business.name }}</h3>
              <p class="business-type">
                {{ business.type.replaceAll("_", " ") }}
              </p>
            </div>
          </div>
        </div>
        <div class="add-business">
          <CircularButton
            color="var(--dark-clr)"
            icon="plus"
            @click="addBusiness"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Button from "@/components/Button.vue";
import CircularButton from "@/components/CircularButton.vue";
import axios from "axios";
import Paw from "@/components/stylistics/Paw.vue";
import Swal from "sweetalert2";
import LoadingScreen from "@/components/LoadingScreen.vue";
import VerticalBreak from "@/components/stylistics/VerticalBreak.vue";

const containsKey = (obj, key) => Object.keys(obj).includes(key);

const Toast = Swal.mixin({
  toast: true,
  position: "bottom-right",
  showConfirmButton: false,
  timer: 5000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  },
});

function validURL(str) {
  var pattern =
    /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/;
  return pattern.test(str);
}

function updatePetFilter(_self) {
  if (_self.petFilter.toLowerCase() === "all") {
    _self.filteredPets = _self.pet;
  } else {
    _self.filteredPets = _self.pet.filter(function (obj) {
      return obj.pet.type == _self.petFilter;
    });
  }
}

function updateBusinessFilter(_self) {
  if (_self.businessFilter.toLowerCase() === "all") {
    _self.filteredBusiness = _self.business;
  } else {
    _self.filteredBusiness = _self.business.filter(function (obj) {
      return obj.type == _self.businessFilter;
    });
  }
}

let allowedFileExtensions = ["jpg", "png", "jpeg"];

let headers = {};

export default {
  name: "Profile",
  components: {
    Navbar,
    Button,
    Paw,
    CircularButton,
    LoadingScreen,
    VerticalBreak,
  },
  data() {
    return {
      profileImage: "",
      firstName: "",
      lastName: "",
      email: "",
      imageFile: "",
      newPet: {
        name: "",
        breed: "",
        age: "",
        type: "",
        gender: "",
      },
      pet: [],
      business: {},
      device: "",
      backend: "",
      petFilter: "all",
      businessFilter: "all",
      filteredPets: [],
      filteredBusiness: [],
    };
  },
  mounted() {
    let title = "Profile - Dating4Pets";
    document.title = title;
    let self = this;
    let jwt = localStorage.getItem("jwt");
    if (jwt == null) {
      self.$router.push("/");
    }

    this.backend = process.env.VUE_APP_BACKEND;

    headers = {
      Authorization: "Bearer " + jwt,
    };
    headers["content-type"] = "application/json";

    axios
      .get(`${process.env.VUE_APP_BACKEND}/users/info`, {
        headers: headers,
      })
      .then(function (res) {
        self.firstName = res.data.firstName;
        self.lastName = res.data.lastName;
        self.email = res.data.email;
        if (
          containsKey(res.data, "profileImage") &&
          res.data.profileImage !== "string" &&
          res.data.profileImage !== ""
        ) {
          if (validURL(res.data.profileImage)) {
            self.profileImage = res.data.profileImage;
          } else {
            // GET IMAGE WITH GET REQUEST
            axios
              .get(
                `${process.env.VUE_APP_BACKEND}/users/images/${res.data.profileImage}`,
                {
                  headers: headers,
                }
              )
              .then(function () {
                self.profileImage = `${process.env.VUE_APP_BACKEND}/users/images/${res.data.profileImage}`;
              })
              .catch(() => {
                self.profileImage = "/paw.svg";
              });
          }
        } else {
          self.profileImage = "/paw.svg";
        }
        setTimeout(() => {
          let loadingScreen = document.querySelector("#loading-screen");
          loadingScreen.classList.add("fade-out");
        }, 1000);
      })
      .catch((err) => {
        // console.log(err.response.data.statusCode);
        if (err.response.data.statusCode == 401) {
          localStorage.removeItem("jwt");
          self.$router.push("/");
        } else {
          Toast.fire("Error", `${err}`, "error");
        }
      });

    axios
      .get(`${process.env.VUE_APP_BACKEND}/pets`, {
        headers: headers,
      })
      .then((res) => {
        this.pet = res.data;
        // console.log(this.pet);
        for (const index in this.pet) {
          axios
            .get(
              `${process.env.VUE_APP_BACKEND}/pets/images/${this.pet[index]._id}`,
              {
                headers: headers,
              }
            )
            .then(() => {
              this.pet[index][
                "image"
              ] = `${process.env.VUE_APP_BACKEND}/pets/images/${this.pet[index]._id}`;
            })
            .catch(() => {
              this.pet[index]["image"] = "/paw.svg";
            });
        }
        updatePetFilter(this);

        console.log("Filtered Pets: ", this.filteredPets);
      })
      .catch((err) => {
        if (err.response) {
          if (err.response.data.statusCode == 404) {
            Toast.fire(" ", "You have no pets yet.", "info");
          } else if (err.response.data.statusCode == 401) {
            localStorage.removeItem("jwt");
            self.$router.push("/");
          } else {
            Toast.fire("An error occured.", err.response.data.message, "error");
          }
        }
      });

    axios
      .get(`${process.env.VUE_APP_BACKEND}/business`, {
        headers: headers,
      })
      .then((res) => {
        this.business = res.data;
        for (const index in this.business) {
          axios
            .get(
              `${process.env.VUE_APP_BACKEND}/business/images/${this.business[index]._id}`,
              {
                headers: headers,
              }
            )
            .then(() => {
              this.business[index][
                "image"
              ] = `${process.env.VUE_APP_BACKEND}/business/images/${this.business[index]._id}`;
            })
            .catch(() => {
              this.business[index]["image"] = "/paw.svg";
            });
        }

        updateBusinessFilter(this);
      })
      .catch((err) => {
        if (err.response.data.statusCode == 404) {
          Toast.fire(" ", "You have no businesses yet.", "info");
        } else if (err.response.data.statusCode == 401) {
          localStorage.removeItem("jwt");
          self.$router.push("/");
        } else {
          Toast.fire("An error occured.", err.response.data.message, "error");
        }
      });

    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      // true for mobile device
      this.device = "mobile";
    } else {
      // false for not mobile device
      this.device = "desktop";
    }
  },
  methods: {
    handleFileUpload(event, id, mode) {
      let self = this;

      // VALIDATE THE FILE
      let splitFilename = event.target.files[0].name.split(".");
      let fileExtension = splitFilename[splitFilename.length - 1];
      // IF THE FILE IS OF AN UNSUPPORTED TYPE, RETURN WHILE THROWING AN ERROR
      if (!allowedFileExtensions.includes(fileExtension)) {
        Swal.fire(
          "Error",
          "The file you uploaded is not supported. Try uploading a file with a valid extension. <br/><b>Valid extensions:</b> " +
            allowedFileExtensions,
          "error"
        );
        return;
      }

      self.imageFile = event.target.files[0];
      Swal.fire({
        title: "Upload Image?",
        html: "You have uploaded a file: <b>" + self.imageFile.name + "</b>",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Upload",
      }).then((res) => {
        if (res.isConfirmed) {
          this.submitImage(id, mode);
        }
      });
    },
    submitImage(id, mode) {
      let formData = new FormData();
      formData.append("file", this.imageFile);
      // console.log(formData);
      let self = this;

      let jwt = localStorage.getItem("jwt");
      if (jwt == null) {
        Swal.fire(
          "An error occured!",
          "Please refresh the page.",
          "error"
        ).then((res) => {
          if (res.isConfirmed) {
            self.$router.push("/");
          }
        });
      }

      const headers = {
        Authorization: "Bearer " + jwt,
        "content-type": "multipart/form-data",
      };
      if (id != null) {
        // console.log("ID: ", id);
        // return;
        let postURL = "";
        switch (mode) {
          case "business":
            postURL = `${process.env.VUE_APP_BACKEND}/business/${id}/image/upload`;
            break;
          case "pet":
            postURL = `${process.env.VUE_APP_BACKEND}/pets/${id}/image/upload`;
            break;
          default:
            break;
        }
        axios
          .post(postURL, formData, {
            headers: headers,
          })
          .then(() => {
            Swal.fire(
              "Uploaded new file",
              `Your image has been uploaded successfully.`,
              "success"
            ).then(() => {
              self.$router.go();
            });
          })
          .catch((err) => {
            Swal.fire(
              "Error",
              "An error occured while uploading your image. <br>Error: " + err,
              "error"
            ).then(() => {
              self.$router.go();
            });
          });
      } else {
        axios
          .post(`${process.env.VUE_APP_BACKEND}/users/upload`, formData, {
            headers: headers,
          })
          .then(() => {
            Swal.fire(
              "Uploaded new file",
              "Your image has been uploaded successfully.",
              "success"
            ).then(() => {
              self.$router.go();
            });
          })
          .catch((err) => {
            Swal.fire(
              "Error",
              "An error occured while uploading your image. <br>Error: " + err,
              "error"
            ).then(() => {
              self.$router.go();
            });
          });
      }
    },
    addPet() {
      let self = this;

      self.$router.push("/add_pet");
    },
    addBusiness() {
      let self = this;

      self.$router.push("/add_business");
      // console.error("Not yet implemented");
    },
    editPet(id) {
      let self = this;
      self.$router.push(`/edit_pet?id=${id}`);
    },
    editBusiness(id) {
      let self = this;
      self.$router.push(`/edit_business?id=${id}`);
    },
    updatePetFilterMethod() {
      updatePetFilter(this);
    },
    updateBusinessFilterMethod() {
      updateBusinessFilter(this);
    },
  },
};
</script>

<style scoped>
.blob-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: -2;
  overflow: hidden;
}

.svg-clipper {
  filter: drop-shadow(0 0 50px black);
}

.profile-section {
  margin-block-start: 10em;
  overflow: visible;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-width: 15em;
  width: 70%;
  max-width: 100em;
  margin-inline: auto;
}

.profile-info {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: var(--gap);
  overflow: visible;
  margin-block-end: 2em;
  min-width: 15em;
  width: 80%;
  max-width: 46em;
  align-self: flex-start;
  align-self: center;
  justify-content: center;
  margin-inline-start: 4em;
}

.profile-image {
  background: #0000;
  background: var(--light-clr);
  border-radius: 50%;
  min-width: 10em;
  width: 10%;
  max-width: 30em;
  aspect-ratio: 1;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  transition: var(--transition);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  box-shadow: var(--light-box-shadow);
}

/* .profile-image img { */
/* transform: rotate(180deg); */
/* width: 100%; */
/* aspect-ratio: 1; */
/* } */

.profile-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--gap);
  overflow: visible;
  margin-inline: 2em;
}

#email {
  margin-block-end: 1em;
}

.page-section {
  margin: 1em;
  overflow: visible;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.section-header {
  margin-block: 1em;
}

input[type="file"] {
  /* display: none; */
  display: block;
  width: 100%;
  opacity: 0;
  position: absolute;
  height: 100%;
  cursor: pointer;
}

.photo-uploader:hover,
.photo-uploader:focus {
  opacity: 1;
}

.profile-image:hover {
  box-shadow: var(--box-shadow-focus);
}

#upload-icon {
  width: 30%;
  height: 30%;
  color: var(--light-clr);
  /* margin: auto; */
}

.pet,
.business {
  display: flex;
  flex-direction: column;
  gap: var(--gap);
  align-items: center;
  justify-content: center;
  overflow: visible;
  position: relative;
  /* min-width: 12em;
  width: 100%;
  max-width: 15em; */
  width: 15em;
  /* padding: 2em 5rem; */
  padding: 2em;
  margin: 2em;
  background: var(--light-clr);
  box-shadow: var(--light-box-shadow);
  border-radius: 1em;
}

.pet-info,
.business-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--gap);
  width: 50%;
  /* margin-inline-start: 1em; */
  position: relative;
  overflow: visible;
  /* width: max-content; */
  width: 80%;
  margin: 2em;
  justify-content: center;
  /* align-items: center; */
  transition: var(--transition);
}

.pet-race {
  font-size: 1em;
  font-weight: 700;
  /* height: max-content; */
  white-space: nowrap;
  /* align-self: flex-start; */
  text-align: initial;
}

.pet-race .pet-breed,
.business-type {
  /* background: red; */
  font-size: 1em;
  white-space: normal;
  font-weight: 100;
}

.pet-image,
.business-image {
  position: relative;
  background: var(--light-clr);
  border-radius: 100%;
  min-width: 7em;
  width: 7%;
  max-height: 21%;
  aspect-ratio: 1;
  cursor: pointer;
  box-shadow: var(--light-box-shadow);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: var(--transition);
}

.pet-image img,
.business-image img {
  width: 100%;
  /* aspect-ratio: 1; */
}

.pet-image:hover,
.pet-image:focus,
.business-image:hover,
.business-image:focus {
  box-shadow: var(--box-shadow-focus);
}

.pet-image:hover > .photo-uploader,
.pet-image:focus > .photo-uploader,
.business-image:hover > .photo-uploader,
.business-image:focus > .photo-uploader {
  opacity: 1;
}

.add-pet,
.add-business {
  overflow: visible;
  margin-block-start: 2em;
  display: flex;
  align-items: center;
  justify-content: center;
}

.edit-pet,
.edit-business {
  position: absolute;
  top: 2em;
  right: 2em;
  width: 5em;
  aspect-ratio: 1;
  color: var(--light-clr);
  border-radius: 50%;
  border: none;
  background: var(--dark-clr);
  transition: box-shadow var(--transition);
  transition: var(--transition);
  cursor: pointer;
  opacity: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
}

.edit-pet.mobile .edit-business.mobile {
  opacity: 1;
}

.edit-pet::before,
.edit-business::before {
  content: "";
  position: absolute;
  width: 0;
  aspect-ratio: 1;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  transition: var(--transition);
}

.pet:hover > .edit-pet,
.pet:focus > .edit-pet,
.business:hover > .edit-business,
.business:hover > .edit-business,
.edit-pet:hover,
.edit-pet:focus,
.edit-business:hover,
.edit-business:focus {
  opacity: 1;
}

.edit-pet:hover::before,
.edit-pet:focus::before,
.edit-business:hover::before,
.edit-business:focus::before {
  width: 110%;
}

.edit-pet:focus,
.edit-pet:hover,
.edit-business:hover,
.edit-business:focus {
  box-shadow: var(--box-shadow-focus);
}

.edit-pet:focus ~ *,
.edit-pet:hover ~ *,
.edit-business:hover ~ *,
.edit-business:focus ~ * {
  filter: blur(0.25em);
}

.edit-pet svg,
.edit-business svg {
  width: 40%;
  height: 40%;
}

.pets-container,
.business-container {
  overflow: visible;
  align-items: start;
  display: grid;
  justify-items: center;
  grid-auto-rows: 1fr;
  width: 80%;
  grid-template-columns: repeat(auto-fill, minmax(15em, 2fr));
  grid-gap: 2em;
}

.user-assets {
  display: flex;
  flex-direction: row;
  flex-direction: column;
  width: 100%;
  overflow: visible;
}

@media screen and (max-width: 46rem) {
  #name {
    font-size: 1.5em;
  }
  #email {
    font-size: 0.8em;
  }
  .profile-info {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0;
    align-self: center;
  }
  .profile-text {
    align-items: center;
    justify-content: center;
    margin-block-end: 3em;
  }
  .pets-container,
  .business-container {
    width: 100%;
  }
}

@media screen and (max-width: 54rem) {
  .pets-container,
  .business-container {
    flex-direction: column;
    /* grid-template-columns: repeat(3, 1fr); */
  }
}

.filter {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: var(--gap);
  font-size: 1.2em;
  overflow: visible;
}

.filter label {
  overflow: visible;
}

@media screen and (max-width: 40rem) {
  .filter {
    flex-direction: column;
  }
}

.select {
  overflow: visible;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

select {
  border: none;
  width: 10em;
  padding: 1em;
  background: white;
  border-radius: 4em;
  color: #454545;
  cursor: pointer;
  font-size: inherit;
  box-shadow: var(--light-box-shadow);
  appearance: none;
  transition: var(--transition);
  z-index: 2;
}

.select::after {
  content: "";
  width: 2em;
  aspect-ratio: 1;
  top: 60%;
  left: calc(50% - 1em);
  background: white;
  transform: rotate(45deg);
  position: absolute;
  border-radius: var(--border-radius);
  box-shadow: var(--light-box-shadow);
  z-index: 1;
  transition: var(--transition);
  opacity: 0;
}

.select:hover select,
.select:focus select,
.select:hover::after,
.select:focus::after {
  box-shadow: var(--box-shadow-focus);
  opacity: 1;
}
</style>
